import { tbGraphics } from "../engine/tbGraphics";
import { tbVectorFont } from "../engine/tbVectorFont";
import { ComponentContainer } from "../framework/components/ComponentContainer";
import { ComponentPicture } from "../framework/components/ComponentPicture";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfDialogs } from "../framework/dialogs/tgfDialogs";
import { tgfFramework } from "../framework/tgfFramework";
import { tgfFunctions } from "../framework/tgfFunctions";
import { tgfGraphics } from "../framework/tgfGraphics";
import { tgfSettings } from "../framework/tgfSettings";
import { AngryAnalytics } from "./Analytics/Analytics";
import { rovio_logo, coolgames_logo } from "./AssetDefinitions/ImageDefinitions";
tgfSettings.dialogDefaults.SplashScreenDialog = {
    timer: 0,
    timeThresholds: {
        "logo1": {
            time: 1500,
            done: false
        },
        "logo2": {
            time: 1500,
            done: false
        },
        "loadSpines": {
            time: "_loadResources is async and spines have issues so we're loading it here -Sam",
            done: false
        }
    },
    copyright_offset: { x: 0, y: -80 },
    _legalDuration: 0,
    coolgamesText: "PUBLISHER_CG",
    rovioText: "PUBLISHER_ROVIO",
    isShowingGamebotOptInMessage: false,
};
export var SplashScreenDialog = function (isWinner, properties) {
    "use strict";
    this.name = "SplashScreenDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.SplashScreenDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    // This permanently sets the background to white?
    this.coolgamesBackground = tbGraphics.drawRectangle(0, 0, tgfGraphics.areaWidth, tgfGraphics.areaHeight, 0xffffff, null, 0, 1);
    tgfGraphics.addChild(this.coolgamesBackground);
};
tgfDialogs.inherit(SplashScreenDialog, DialogBase);
SplashScreenDialog.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    this.components = [];
    this.rovioContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.rovio = new ComponentPicture({
        image: rovio_logo
    });
    this.rovioContainer.addComponent(this.rovio);
    this.addComponent(this.rovioContainer);
    this.coolgamesContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.coolGames = new ComponentPicture({
        image: coolgames_logo
    });
    this.coolgamesContainer.addComponent(this.coolGames);
    this.addComponent(this.coolgamesContainer);
    this.copyrightText = new tbVectorFont();
    this.copyrightText.setProperties({
        fontFace: "Arial",
        fontSize: 26,
        fillColor: "#0971CE",
        align: "center",
        text: "©",
        x: tgfGraphics.areaWidth / 2 + this.copyright_offset.x,
        y: tgfGraphics.areaHeight + this.copyright_offset.y,
        wordWrap: true,
        wordWrapWidth: tgfGraphics.areaWidth * 0.95
    });
    this.copyrightText.setPosition(tgfGraphics.areaWidth / 2 + this.copyright_offset.x, tgfGraphics.areaHeight + this.copyright_offset.y);
    this.copyrightText.setText(tgfDictionary.getText(this.coolgamesText));
    this.baseContainer.addChild(this.copyrightText);
    // FBInstant.player.canSubscribeBotAsync().then(function(canSubscribe) {
    // 	if (canSubscribe) {
    // 		AngryAnalytics.reportGamebotOptInOpen();
    // 		FBInstant.player.subscribeBotAsync().then(function() {
    // 			AngryAnalytics.reportGamebotOptInClose(true);
    // 			self.isShowingGamebotOptInMessage = false;
    // 		}).catch(function(err) {
    // 			AngryAnalytics.reportGamebotOptInClose(false);
    // 			self.isShowingGamebotOptInMessage = false;
    // 		});
    // 	} else {
    // 		self.isShowingGamebotOptInMessage = false;
    // 	}
    // }).catch(function(err) {
    // 	self.isShowingGamebotOptInMessage = false;
    // });
    // this.isShowingGamebotOptInMessage = true;
};
SplashScreenDialog.prototype.handleEndStep = function (timePassed) {
    "use strict";
    if (this.timer == 0) { // Cheap hack
        this.rovioContainer.hide();
    }
    if (!this.isShowingGamebotOptInMessage) {
        this.timer += timePassed;
    }
    if (this.timer >= this.timeThresholds["logo1"].time && this.timeThresholds["logo1"].done === false) {
        this.timeThresholds["logo1"].done = true;
        this.copyrightText.setText(tgfDictionary.getText(this.rovioText));
        this.copyrightText.setPosition(this.copyrightText.x, this.copyrightText.y - 30);
        this.copyrightText.setFillColor("#FF0026");
        this.rovioContainer.show();
        this.coolgamesContainer.hide();
        this._legalDuration = Date.now();
    }
    else if (this.timer >= (this.timeThresholds["logo1"].time + this.timeThresholds["logo2"].time) && this.timeThresholds["logo2"].done === false) {
        if (tgfFunctions.loadComplete()) {
            tgfFramework._loadResources(["spine"], ["spine"]);
            this.timeThresholds["logo2"].done = true;
        }
    }
    else if (this.timeThresholds["logo2"].done === true &&
        this.timeThresholds["logo1"].done === true &&
        this.timeThresholds['loadSpines'].done === false) {
        // Done
        if (tgfFunctions.loadComplete()) {
            AngryAnalytics.reportLegalScreenDuration(Date.now() - this._legalDuration);
            this.timeThresholds['loadSpines'].done = true;
            // This is set to onHide instead of hide because we want to move
            // the code that handles the waiting for initialization to the flowController
            if (this.onHide) {
                this.onHide();
            }
        }
    }
};
// Processing required when showing the dialog
SplashScreenDialog.prototype.doShow = function () {
    "use strict";
    this.hidden = false;
    ytgame.game.firstFrameReady();
};
